// Copyright 2024, Imprivata, Inc.  All rights reserved.

export const Endpoints = {
  AAD_CONSENT_URL: '/am-portal-setup-svc/tenant-setup/v1/aad-consent-url/get',
  COMPLETE_SETUP: '/am-portal-setup-svc/tenant-setup/v1/complete',
  CONSENT_CHECK: '/am-portal-svc/user-consent/v1/consent/check',
  CONSENT_SUBMIT: '/am-portal-svc/user-consent/v1/consent/submit',
  CONSENT_REVOKE: '/am-portal-svc/user-consent/v1/consent/revoke',
  DIR_INITIAL_SYNC: '/am-portal-svc/directory/v1/initial-sync/start',
  DIR_FAILED_SYNC_FIND: '/am-portal-svc/directory/v1/directories/failed-sync/find',
  DIR_FIND: '/am-portal-svc/directory/v1/directories/find',
  DIR_SYNC: '/am-portal-svc/directory/v1/directories/sync',
  DIR_SYNC_PROGRESS: '/am-portal-svc/directory/v1/directories/sync-progress/get',
  DOMAINS_VALIDATE: '/am-portal-setup-svc/tenant-service/v1/domains/validate',
  DPA_CHECK: '/am-portal-setup-svc/user-consent/v2/consent/dpa-check',
  ENTRA_ID_CONSENT: '/am-portal-svc/entra-id/v1/entra-id-consent-url/get',
  ENTRA_ID_SETUP_COMPLETE: '/am-portal-svc/entra-id/v1/entra-id/setup',
  FIND_AUTHENTICATORS: '/am-portal-svc/authenticators/v1/find/by-user-ids',
  GET_CLIENT_USER_SESSION: '/am-portal-svc/session/v1/client-user-session/get',
  GET_CONSENT_AND_AUTHENTICATORS_DATA: '/am-portal-svc/v2/landing-page/consent-authenticators-data/get',
  GET_GROUPS: '/am-portal-svc/identity-group/v1/groups/find',
  GET_LANDING_PAGE: '/am-portal-svc/v2/landing-page/get',
  GET_IDP_CONFIG_SAML: '/am-portal-svc/icp-config-admin/v1/idp-config-saml/get',
  GROUPS_FIND: '/am-portal-svc/identity-group/v1/groups/find',
  IDP_CONFIG_SAML_FIND: '/am-portal-setup-svc/icp-config-admin/v1/idp-config-saml/find',
  IP_RANGES: '/am-portal-svc/entra-id/v1/entra-id-config/get',
  LOGOUT: '/idp-web/idp/logout',
  MARK_GROUP_SYNC: '/am-portal-svc/identity-group/v1/group-for-sync/mark',
  ORG_INFO_GET: '/am-portal-setup-svc/organization-info/v1/get',
  ORG_INFO_SAVE: '/am-portal-setup-svc/organization-info/v1/save',
  PORTAL_TEMP_CODE_ASSIGN: '/am-portal-svc/temp-code/v1/temp-code/assign',
  PORTAL_TEMP_CODE_METADATA_GET: '/am-portal-svc/temp-code/v1/temp-code-metadata/get',
  PORTAL_CREATE_CLIENT_CREDENTIAL: '/am-portal-svc/connect-administration/v1/client-credential/create',
  PORTAL_IMPR_IDP_DIR_SAVE: '/am-portal-svc/impr-idp-directories/v1/save',
  PORTAL_IMPR_IDP_USER_DETAILS_GET: '/am-portal-svc/impr-idp-users/v1/user/get',
  PORTAL_IMPR_IDP_USERS_FIND: '/am-portal-svc/impr-idp-users/v1/find',
  PORTAL_IMPR_IDP_USERS_SAVE: '/am-portal-svc/impr-idp-users/v1/save',
  PORTAL_IMPR_IDP_USERS_DELETE: '/am-portal-svc/impr-idp-users/v1/delete',
  PORTAL_ORG_PREFERENCES_GET: '/am-portal-svc/preferences/v1/org-preferences/get',
  PORTAL_ORG_PREFERENCES_UPDATE: '/am-portal-svc/preferences/v1/org-preferences/update',
  PORTAL_IMPR_IDP_USERS_UNLOCK: '/am-portal-svc/impr-idp-users/v1/user/unlock',
  SETUP_IMPR_IDP_DIR_ADD: '/am-portal-setup-svc/impr-idp-directories/v1/save',
  SETUP_CREATE_CLIENT_CREDENTIAL: '/am-portal-setup-svc/connect-administration/v1/client-credential/create',
  SETUP_LINK_REGENERATE: '/am-portal-setup-svc/tenant-setup/v1/setup-link/regenerate',
  START_TENANT_SETUP: '/am-portal-setup-svc/tenant-setup/v1/start',
  TENANT_LOOKUP_BY_DOMAIN: '/am-portal-svc/tenant-lookup/v1/tenants-by-domain/get',
  TEST_TENANT_INFO: '/am-portal-svc/tenant-service/v1/tenant-info/get',
  UNENROLL_AUTHENTICATORS: '/am-portal-svc/authenticators/v1/unenroll',
  UNMARK_GROUP_SYNC: '/am-portal-svc/identity-group/v1/group-for-sync/unmark',
  UPDATE_SP_DISPLAY_NAME: '/am-portal-svc/icp-metadata-admin/v1/sp-display-name/update',
  USERS_FIND: '/am-portal-svc/user/v1/users/find',
  GET_SELF_SERVICE_LANDING_PAGE_DATA: '/am-portal-svc/user-self-service/v2/landing-page/get',
  SELF_SERVICE_CHANGE_PASSWORD: '/am-portal-svc/impr-idp-users/v1/password/change',
  SELF_SERVICE_ENROLL: '/am-portal-svc/user-self-service/v1/authenticator/enroll',
  LEGAL_AGREEMENTS_PREPARE: '/am-portal-svc/legal-agreements/v1/file-upload/prepare',
  LEGAL_AGREEMENTS_COMPLETE: '/am-portal-svc/legal-agreements/v1/file-upload/html-to-json/complete',
  LEGAL_AGREEMENTS_RESIDENCE_LOCATIONS: '/am-portal-svc/legal-agreements/v1/residence-locations/save',
  LEGAL_AGREEMENTS_INFO_GET: '/am-portal-svc/legal-agreements/v1/customer-agreement-info/get',
  PORTAL_LEGAL_AGREEMENTS_DELETE: '/am-portal-svc/legal-agreements/v1/document/delete',
  // Setup and Portal
  PREPARE_FILE_UPLOAD: '/am-portal-svc/file-access/v1/prepare-file-upload',
  SAVE_AND_UPDATE_IDP_CONFIG_SAML: '/am-portal-svc/icp-config-admin/v1/idp-config-saml/save',
  IMPR_IDP_DIR_FIND: '/am-portal-svc/impr-idp-directories/v1/find',
  CONNECT_CLIENT_CREATE: '/am-portal-svc/connect-eamc/v1/client/create',
  IDP_GET: '/am-portal-svc/icp-metadata-admin/v1/idp/get',
  IDP_SAVE: '/am-portal-svc/icp-metadata-admin/v1/idp/save',
  IDP_GET_DATA: '/am-portal-svc/impr-idp-directories/v1/impr-idp-data/get',
} as const;

export enum clientHeader {
  SETUP = 'am-portal-tenant-setup-web',
}

export enum AMPortalService {
  AM_PORTAL_SETUP = '/am-portal-setup-svc',
  AM_PORTAL = '/am-portal-svc',
}

export enum SystemType {
  SETUP = 'SETUP',
  PORTAL = 'PORTAL',
}

export const CommonHeaders = {
  'Content-Type': 'application/json',
  'Strict-Transport-Security': 'max-age=86400;includeSubDomains',
  'X-XSS-Protection': '1;mode=block',
  'X-Content-Type-Options': 'nosniff',
  'X-Frame-Options': 'DENY',
};

export const IdpChoices = {
  ENTRA_ID_VALUE: 'entraId',
  EXTERNAL_VALUE: 'external',
  NONE_VALUE: 'none',
} as const;

export const StorageKeys = {
  WORKFLOW_ID: 'ImprWorkflowId',
  TENANT_SETUP_STATE: 'tenantSetupState', // type SetupState
  DPA_STATUS: 'DPA_STATUS', // type DpaStatus
  DPA_DOCUMENT_NAME: 'DPA_DOCUMENT_NAME',
  DPA_DOCUMENT_URL: 'DPA_DOCUMENT_URL',
  ORG_EMAIL: 'orgEmail',
  EXT_IdP_USED: 'EXT_IdP_USED', // type boolean
  IMPR_IDP_USED: 'IMPR_IDP_USED', // type boolean
};

export enum SetupState {
  STARTED = 'started',
  COMPLETED = 'completed',
}

export enum DpaStatus {
  GRANTED = 'GRANTED',
}

export enum ConsentGrantType {
  GRANTED = 'granted',
  NOT_GRANTED = 'not-granted',
  EMPTY = '',
}

export enum ConsentType {
  BIOMETRICS = 'impr.biometrics',
}

export enum SearchParams {
  BEARER_TOKEN = 'bt',
  TENANT_ID = 'tenantId',
  STATE = 'state',
}

export enum FactorType {
  Face = 'face',
}
